import { trackClickEvent, trackClickEventHandler } from "../events/clicks-tracker";
import { selectors, slices, store } from "../user-area/redux/store";
import { callStartTrialAPI } from "../user-area/utils/trial";
import { MultipleChoiceQuestion } from "./multiple-choice-question";

function setupQuestionExtraContent(question: MultipleChoiceQuestion) {
  const extraContent = question.querySelector(
    ".enem-exercises-results-list-item-extra-content"
  );
  if (!extraContent) return;

  const questionExplanationTab = extraContent.querySelector<HTMLInputElement>(
    'input[data-tab="explanation"]'
  );
  const questionExplanationContent = extraContent.querySelector<HTMLElement>(
    ".enem-exercises-results-list-item-extra-content-body--explanation"
  );
  const questionRelatedContentTab =
    extraContent.querySelector<HTMLInputElement>(
      'input[data-tab="related-content"]'
    );

  function onChangeExtraContentTab(e: Event) {
    e.preventDefault();
    e.stopPropagation();
    const target = e.target as HTMLInputElement;
    if (!question.submitted) {
      target.checked = false;
    }
  }

  function onClickExtraContentTab(e: Event) {
    const target = e.target as HTMLInputElement;
    if (!question.submitted) {
      e.preventDefault();
      e.stopPropagation();
      target.checked = false;
      return;
    }

    switch (target.dataset.tab) {
      case "explanation":
        showExplanation(false);
        break;
      case "related-content":
        showRelatedContent();
        break;
      default:
        break;
    }
  }

  function uncheckTab(tabElement: HTMLInputElement | null) {
    if (tabElement) {
      tabElement.checked = false;
    }
  }

  function showExplanation(shouldScroll: boolean = true) {
    if (
      !questionExplanationContent ||
      !questionExplanationTab ||
      !question.submitted
    ) {
      uncheckTab(questionExplanationTab);
      return;
    }

    function lockExplanation(container: HTMLElement) {
      if (!question.explanationLimitReached) {
        container.innerHTML = question.explanation || "";
        return;
      }

      const messages =  {
        'newUser': {
          title: "🔥 Seu esforço merece explicação, não só resposta.",
          description:"Ative <b>7 dias grátis do TM+</b> e destrave <b>gabaritos completos + Tira Dúvidas</b> para você parar de decorar gabarito e entender de verdade",
          preCta: null,
          cta: "Ative 7 dias grátis",
          safeGuarantee: {
            title: "Sem cartão  •  Sem compromisso  •  Desbloqueio imediato",
            icon: null,
          },
        },
        'userHadTrialBefore': {
          title: "Você atingiu o limite gratuito.",
          description: "Desbloqueie perguntas sobre as questões, gabaritos e exercícios explicados ilimitados por menos de R$1/dia.",
          preCta: null,
          cta: "Praticar sem limites",
          safeGuarantee: {
            title: "Compra 100% segura com PIX ou Cartão",
            icon: "icon-061-unlock",
          },
        },
      }

      const explanation = question.explanation || "";
      const title = messages[question.userHadTrialBefore ? 'userHadTrialBefore' : 'newUser'].title;
      const description = messages[question.userHadTrialBefore ? 'userHadTrialBefore' : 'newUser'].description;
      const cta = messages[question.userHadTrialBefore ? 'userHadTrialBefore' : 'newUser'].cta;
      const safeGuarantee = messages[question.userHadTrialBefore ? 'userHadTrialBefore' : 'newUser'].safeGuarantee.title;
      const safeGuaranteeIcon = messages[question.userHadTrialBefore ? 'userHadTrialBefore' : 'newUser'].safeGuarantee.icon;
      const preCta = messages[question.userHadTrialBefore ? 'userHadTrialBefore' : 'newUser'].preCta;

      const lockedExplanationElement = document.createElement("div");
      lockedExplanationElement.classList.add("locked-explanation");

      const lockedExplanationContentElement = document.createElement("div");
      lockedExplanationContentElement.classList.add("locked-explanation-content");
      lockedExplanationContentElement.innerHTML = explanation;

      const lockedExplanationBannerElement = document.createElement("div");
      lockedExplanationBannerElement.classList.add("locked-explanation-banner");

      const lockedExplanationBannerTitleElement = document.createElement("div");
      lockedExplanationBannerTitleElement.classList.add("locked-explanation-banner-title");
      lockedExplanationBannerTitleElement.innerHTML = title;

      const lockedExplanationBannerDescriptionElement = document.createElement("div");
      lockedExplanationBannerDescriptionElement.classList.add("locked-explanation-banner-description");
      lockedExplanationBannerDescriptionElement.innerHTML = description;

      const lockedExplanationBannerActionsElement = document.createElement("div");
      lockedExplanationBannerActionsElement.classList.add("locked-explanation-banner-actions");

      const lockedExplanationBannerCtaIconElement = document.createElement("span");
      lockedExplanationBannerCtaIconElement.classList.add("icon-034-dash-arrow");

      const lockedExplanationBannerCtaElement = document.createElement("a");
      lockedExplanationBannerCtaElement.classList.add("locked-explanation-banner-cta");
      lockedExplanationBannerCtaElement.href = "/tmplus/";
      lockedExplanationBannerCtaElement.setAttribute("data-track-click", "cta-tmplus--gabarito");

      const lockedExplanationBannerCtaPreCtaElement = document.createElement("span");
      lockedExplanationBannerCtaPreCtaElement.classList.add("locked-explanation-banner-cta-pre-cta");
      lockedExplanationBannerCtaPreCtaElement.innerHTML = preCta || "";
      
      lockedExplanationBannerCtaElement.appendChild(document.createTextNode(cta));
      lockedExplanationBannerCtaElement.appendChild(lockedExplanationBannerCtaIconElement);
      if (question.userHadTrialBefore) {
          lockedExplanationBannerCtaElement.addEventListener('click', trackClickEventHandler);
      } else {
          lockedExplanationBannerCtaElement.addEventListener('click', (e) => {
              e.preventDefault();
              e.stopPropagation();
              const state = store.getState();
              const authState = state[slices.auth.name];
              const authData = selectors.auth.credentials(authState);
              const user = selectors.auth.getUser(authState);

              if (user && user.id) {
                  trackClickEvent('cta-exercises-gabarito-trial');
                  callStartTrialAPI(authData, user.id);
              }
          });
      }
      const lockedExplanationBannerSafeGuaranteeElement = document.createElement("span");
      lockedExplanationBannerSafeGuaranteeElement.classList.add("locked-explanation-banner-safe-guarantee");
      if(!safeGuaranteeIcon) {
        lockedExplanationBannerSafeGuaranteeElement.classList.add("locked-explanation-banner-safe-guarantee__no-icon");
      }
      lockedExplanationBannerSafeGuaranteeElement.innerHTML = safeGuarantee;

      lockedExplanationBannerActionsElement.appendChild(lockedExplanationBannerCtaElement);
      lockedExplanationBannerActionsElement.appendChild(lockedExplanationBannerSafeGuaranteeElement);

      lockedExplanationBannerElement.appendChild(lockedExplanationBannerTitleElement);
      lockedExplanationBannerElement.appendChild(lockedExplanationBannerDescriptionElement);
      if(preCta) {
        lockedExplanationBannerElement.appendChild(lockedExplanationBannerCtaPreCtaElement);
      }
      lockedExplanationBannerElement.appendChild(lockedExplanationBannerActionsElement);

      lockedExplanationElement.appendChild(lockedExplanationContentElement);
      lockedExplanationElement.appendChild(lockedExplanationBannerElement);

      container.innerHTML = "";
      container.appendChild(lockedExplanationElement);
      container.classList.add("locked");
    }

    lockExplanation(questionExplanationContent);
    questionExplanationTab.checked = true;
    if (shouldScroll) {
      requestAnimationFrame(() => {
        setTimeout(() => {
          if (!extraContent) return;
          const extraContentContainerRect = extraContent.getBoundingClientRect();
          const extraContentVisibleHeight = 400;
          window.scrollTo({
            top: extraContentContainerRect.top + window.scrollY - (window.innerHeight - extraContentVisibleHeight),
            behavior: "smooth",
          });
        }, 100);
      });
    }
  }

  function showRelatedContent() {
    if (
      !questionRelatedContentTab ||
      !question.submitted
    ) {
      uncheckTab(questionRelatedContentTab);
      return;
    }

    questionRelatedContentTab.checked = true;
  }

  questionExplanationTab?.addEventListener("change", onChangeExtraContentTab);
  questionExplanationTab?.addEventListener("click", onClickExtraContentTab);
  questionRelatedContentTab?.addEventListener("change", onChangeExtraContentTab);
  questionRelatedContentTab?.addEventListener("click", onClickExtraContentTab);

  question.addEventListener("answer-submitted", () => {
    showExplanation();
  });
}

function setup() {
  const questions = document.querySelectorAll<MultipleChoiceQuestion>(
    "multiple-choice-question"
  );
  questions.forEach(setupQuestionExtraContent);
}

window.addEventListener("DOMContentLoaded", setup);
